import dayjs from 'dayjs';

import {
  IBusinessEntityInfo,
  IItemListItem,
  IStoreInfo,
  InvoiceIssuance,
  InvoiceModificationIssuance,
} from '~apis/tax-invoice';

export type PurposeType = 'RECEIPTS' | 'BILLING';
export type TaxationType = 'NORMAL' | 'TAX_FREE' | 'TAX_ZERO';
export type IssuanceType = 'FORWARD' | 'REVERSE' | 'CONSIGNMENT';

export type TAX_INVOICE_STATUS =
  | 'IN_PROGRESS'
  | 'SCHEDULED'
  | 'SENDING'
  | 'COMPLETED'
  | 'FAILED'
  | '';

export type TaxInvoiceItem = {
  price: number;
  supplyPrice: number;
  taxPrice: number;
  totalPrice: number;
  quantity: number;
};

export type ISSUE_TYPE = 'default' | 'edit';

export type IssuanceFormData = Omit<
  InvoiceIssuance,
  | 'depositInfo'
  | 'issueDate'
  | 'writtenDate'
  | 'contractorInfo'
  | 'businessEntityInfo'
  | 'depositInfo'
  | 'emailResends'
> & {
  issueDate: dayjs.Dayjs;
  writtenDate: dayjs.Dayjs;
  depositInfo: {
    depositDate: dayjs.Dayjs;
    depositAmount: number;
  };
  originItemList?: IItemListItem[];
  contractorManualInfo?: Partial<IStoreInfo>;
  contractorInfo?: Partial<IStoreInfo>;
  businessEntityInfo?: Partial<IBusinessEntityInfo>;
  emailResends?: string[];
};

export type IssuanceUpdateFormData = Omit<
  InvoiceModificationIssuance,
  | 'depositInfo'
  | 'issueDate'
  | 'writtenDate'
  | 'contractorInfo'
  | 'businessEntityInfo'
  | 'depositInfo'
  | 'changeInSupplyPrice'
  | 'returnOfGoods'
  | 'contractCancelled'
  | 'postOpeningLocalLc'
  | 'emailResends'
> & {
  issueDate: dayjs.Dayjs;
  writtenDate: dayjs.Dayjs;
  depositInfo: {
    depositDate: dayjs.Dayjs;
    depositAmount: number;
  };
  originItemList?: IItemListItem[];
  contractorManualInfo?: Partial<IStoreInfo>;
  contractorInfo?: Partial<IStoreInfo>;
  businessEntityInfo?: Partial<IBusinessEntityInfo>;
  emailResends?: string[];
  changeInSupplyPrice?: {
    changeDate: dayjs.Dayjs;
    itemList: IItemListItem[];
  };
  returnOfGoods?: {
    changeDate: dayjs.Dayjs;
    itemList: IItemListItem[];
  };
  contractCancelled?: {
    cancelDate: dayjs.Dayjs;
  };
  postOpeningLocalLc?: {
    localLcOpeningDate: dayjs.Dayjs;
  };
};

export const TaxationData = {
  TAX_FREE: '면세',
  TAX_ZERO: '영세',
  NORMAL: '일반',
};

export const PurposeData = {
  RECEIPTS: '영수',
  BILLING: '청구',
};

export const getAvailableDates = ({
  date,
  key,
  targetDate,
}: {
  date: dayjs.Dayjs;
  key: string;
  targetDate?: dayjs.Dayjs;
}) => {
  if (key === 'writtenDate' || key === 'changeDate') {
    return date.isAfter(dayjs().subtract(1, 'month').startOf('month'));
  }
  if (key === 'issueDate') {
    return (
      date.isAfter(dayjs().add(1, 'D')) &&
      date.isBefore(dayjs(targetDate).add(1, 'M').startOf('month').add(10, 'day'))
    );
  }

  return true;
};
